import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { addInspection, resetInspection } from "../../redux/inspectionSlice";
import { surveySelector } from "../../redux/surveySlice";
import InspectionViewModal from "../survey-form/InspectionViewModal";
import NoInspection from "../admin-component/survey/NoInspection";

const CardInspectionList = (props) => {
  const { inspection } = useSelector(surveySelector);
  const dispatch = useDispatch();
  const [modalDetail, setModalDetail] = useState(false);

  const handleEdit = (inspect, index) => {
    props.onOpen();
    props.onIndex(index);
    dispatch(addInspection(inspect));
  };

  const handleView = (inspect) => {
    setModalDetail(true);
    dispatch(addInspection(inspect));
  };
  return (
    <>
      {inspection?.length > 0 ? (
        inspection.map((inspect, index) => (
          <div className="mediaList mb-3" key={index}>
            <div className="media-body" onClick={() => handleView(inspect)}>
              <h4>Building # {index + 1}</h4>
              <p>{inspect?.code}</p>
            </div>
            <Link to="#" className="cta">
              <Icon
                icon="carbon:edit"
                onClick={() => handleEdit(inspect, index)}
              />
            </Link>
          </div>
        ))
      ) : props.showAdd ? (
        <></>
      ) : (
        <NoInspection />
      )}
      <InspectionViewModal
        show={modalDetail}
        onHide={() => {
          setModalDetail(false);
          dispatch(resetInspection());
        }}
      />
    </>
  );
};

export default CardInspectionList;
